import { Button } from '@mui/material';
import PhotoCameraFrontOutlinedIcon from '@mui/icons-material/PhotoCameraFrontOutlined';
import { Paths } from '@shared/AppRoutes';
import { getDateShort } from '@shared/entity';

const DateButton = (props: {
  visitDate: Date;
  clientId: string;
  visitId: string;
  navigate: (path: string) => void;
}) => {
  const { visitDate, clientId, visitId, navigate } = props;

  return (
    <Button
      sx={{ paddingY: '2px' }}
      endIcon={<PhotoCameraFrontOutlinedIcon />}
      onClick={() => navigate(Paths.visitDetail(clientId, visitId))}
    >
      {getDateShort(visitDate)}
    </Button>
  );
};

export default DateButton;
